export const getNameInitials = (first_name, last_name) => {
  if (first_name && last_name)
    return `${first_name.charAt(0)}${last_name.charAt(0)}`;
  else if (first_name && !last_name) return `${first_name.charAt(0)}`;
  else return "--";
};
